import script from "./returnReport.vue?vue&type=script&setup=true&lang=js"
export * from "./returnReport.vue?vue&type=script&setup=true&lang=js"

import "./returnReport.vue?vue&type=style&index=0&id=4ce2f6eb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ce2f6eb"]])

export default __exports__